import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  hr: {
    display: "flex",
    flexBasis: "100%",
    alignItems: "center",
    color: "rgba(0, 0, 0, 0.35)",
    width: '100%',
    margin: '10px 0',
    maxWidth: '360px',
    '&::before': {
      content: '""',
      flexGrow: 1,
      background: "rgba(0, 0, 0, 0.35)",
      height: "1px",
      fontSize: "0px",
      lineHeight: "0px",
      margin: "0px 8px 0px 0px",
    },
    '&::after': {
      content: '""',
      flexGrow: 1,
      background: "rgba(0, 0, 0, 0.35)",
      height: "1px",
      fontSize: "0px",
      lineHeight: "0px",
      margin: "0px 0px 0px 8px",
    },
    ['@media (max-width: 320px)']: {
      maxWidth: '80%'
    },
    ['@media (max-width: 375px)']: {
      maxWidth: '80%'
    }
  },
  brandsWrapper: {
    padding: `var(--regsgap) var(--reggap) var(--reggap) var(--reggap)`,
    width: '100%',
  },
  brandsImageSingle: {
    width: '70px',
    height: '70px'
  },
  brandsWrapperTitle: {
    display: `flex`,
    flexDirection: `row`,
    '&::before': {
      content: '""',
      marginRight: '10px',
      flex: '1 1',
      borderBottom: '1px solid var(--clr_pastbluegrey)',
      margin: 'auto',
    },
    '&::after': {
      content: '""',
      marginLeft: '10px',
      flex: '1 1',
      borderBottom: '1px solid var(--clr_pastbluegrey)',
      margin: 'auto',
    },
    '& span': {
      fontSize: 'var(--fs_small)',
      color: 'var(--clr_pastbluegrey)'
    }
  },
  brandsWrapperImage: {
    maxWidth: '100%',
    display: 'inline-block',
    margin: '5px auto 0 auto',
    '& img': {
      width: '100%',
    }
  },
  swiperWrapper: {
    width: '100%',
  },
  swiperSlide: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export default useStyles;
